import * as React from "react";
import CookieBanner from "./cookiebanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import Translate from '../general/translate';
import GlobalStateContext from "./globalState";

const Footer = () => {

  const { language } = React.useContext(GlobalStateContext);

  const getLocalizedLink = (path: string) => {
    return language === 'en' ? path : `/${language}${path}`;
  };

  return (
    <footer className="bg-[#27004F] border-[#301d58] border-t-2">
      <CookieBanner />
      <div className="mx-auto w-5/6 p-4 py-6 lg:py-12">
        <div className="md:flex md:justify-between">
          <div className="mb-10 md:mb-0">
            <a href="/" className="cursor-pointer">
              <img src="/logos/podsqueezelogo.png" alt="Podsqueeze Logo" className="cursor-pointer h-6 m-auto sm:mr-10 mb-5" />
            </a>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:gap-10 sm:grid-cols-4 text-center sm:text-left">
            <div>
              <p className="mb-6 text-sm font-extrabold text-[#fafafa] uppercase">
                <Translate id="footer.features" foldername="general" filename="footer" />
              </p>
              <ul className="text-[#9685a7] font-medium">
                <li className="mb-3">
                  <a href={getLocalizedLink("/ai-podcast-transcript-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.transcriptGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-subtitle-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.subtitlesGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-description-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.descriptionGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-summary-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastSummarizer" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-title-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.titlesGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/episode-title-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.episodeTitleGenerator" foldername="general" filename="footer" defaultValue="Episode Title Generator" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-bullet-points-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.bulletPointsGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-chapters-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.chaptersClipsGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-social-media-posts/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.socialMediaPostsGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-newsletter-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.newsletterGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/convert-voice-to-blog/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.blogPostGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/create-podcast-landing-page/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastLandingPages" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-clip-maker/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastClipMaker" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/audiogram-generator/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.audiogramGenerator" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/ai-audio-enhancer/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.aiAudioEnhancer" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/convert-youtube-video-to-text/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.convertYoutubeToText" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/remove-noise-from-youtube-video/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.youtubeVideoNoiseRemover" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/youtube-video-key-points/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.youtubeVideoKeyPoints" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/monetize-podcast/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.monetizePodcast" foldername="general" filename="footer" defaultValue="Monetize Your Podcast" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-bonus-content/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastBonusContent" foldername="general" filename="footer" defaultValue="Podcast Bonus Content" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-coaching/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastCoaching" foldername="general" filename="footer" defaultValue="Podcast Coaching" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-content-marketing/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastContentMarketing" foldername="general" filename="footer" defaultValue="Podcast Content Marketing" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-marketing-agency/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastMarketingAgency" foldername="general" filename="footer" defaultValue="Podcast Marketing Agency" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-production-agency/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastProductionAgency" foldername="general" filename="footer" defaultValue="Podcast Production Agency" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-production-software/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastProductionSoftware" foldername="general" filename="footer" defaultValue="Podcast Production Software" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/podcast-video-editing/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.podcastVideoEditing" foldername="general" filename="footer" defaultValue="Podcast Video Editing" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/proofread-transcripts/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.proofreadTranscripts" foldername="general" filename="footer" defaultValue="Proofread Transcripts" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/repurpose-content/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.repurposeContent" foldername="general" filename="footer" defaultValue="Repurpose Content" />
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <p className="mb-6 text-sm font-extrabold text-[#fafafa] uppercase">
                <Translate id="footer.freeResources" foldername="general" filename="footer" />
              </p>
              <ul className="text-[#9685a7] font-medium">
                <li className="mb-4">
                  <a href="https://www.topicsforpodcasts.com" className="hover:text-[#fafafa]">
                    <Translate id="footer.findPodcastTopicIdeas" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/blog/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.articles" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href="https://podsqueeze.gumroad.com/" className="hover:text-[#fafafa]">
                    <Translate id="footer.freeEbooks" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href="https://podsqueezeteam.slack.com/" className="hover:text-[#fafafa]">
                    <Translate id="footer.community" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/#podcast")} className="hover:text-[#fafafa]">
                    <Translate id="footer.ourPodcast" foldername="general" filename="footer" />
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="mb-6 text-sm font-extrabold text-[#fafafa] uppercase">
                <Translate id="footer.product" foldername="general" filename="footer" />
              </p>
              <ul className="text-[#9685a7] font-medium">
                <li className="mb-3">
                  <a href={getLocalizedLink("/best-gift-for-a-podcaster/")} className="hover:text-[#fafafa]">
                    <FontAwesomeIcon icon={faGift} className="text-[#FFCA1D] text-sm mr-2" />
                    <Translate id="footer.giftCard" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/blog/podsqueeze-onboarding-ai-shownotes-podcast/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.onboardingEbook" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/pricing/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.pricing" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/affiliates/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.affiliates" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/media/")} className="hover:text-[#fafafa]">
                    <Translate id="footer.media" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href={getLocalizedLink("/#testimonials")} className="hover:text-[#fafafa]">
                    <Translate id="footer.testimonials" foldername="general" filename="footer" />
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="mb-6 text-sm font-extrabold text-[#fafafa] uppercase">
                <Translate id="footer.legal" foldername="general" filename="footer" />
              </p>
              <ul className="text-[#9685a7] font-medium">
                <li className="mb-3">
                  <a href="/privacy-policy/" className="hover:text-[#fafafa]">
                    <Translate id="footer.privacyPolicy" foldername="general" filename="footer" />
                  </a>
                </li>
                <li className="mb-3">
                  <a href="/terms-of-use/" className="hover:text-[#fafafa]">
                    <Translate id="footer.termsOfUse" foldername="general" filename="footer" />
                  </a>
                </li>
                <li>
                  <a href="/refund-policy/" className="hover:text-[#fafafa]">
                    <Translate id="footer.refundPolicy" foldername="general" filename="footer" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-[#87719e] sm:mx-auto lg:my-10" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm text-[#9685a7] sm:text-center">
            © 2024 <a href="https://podsqueeze.com/" className="hover:underline">Podsqueeze™ - USERQUEST LDA.</a> <Translate id="footer.allRightsReserved" foldername="general" filename="footer" />
          </span>
          <div className="flex mt-4 space-x-5 sm:justify-center sm:mt-0">
            <a href="https://www.facebook.com/profile.php?id=100093779395164" className="text-[#9685a7] hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 8 19">
                <path fillRule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clipRule="evenodd" />
              </svg>
              <span className="sr-only">Facebook page</span>
            </a>
            <a href="https://twitter.com/podsqueeze_app" className="text-[#9685a7] hover:text-gray-900 dark:hover:text-white">
              <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 17">
                <path fillRule="evenodd" d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z" clipRule="evenodd" />
              </svg>
              <span className="sr-only">Twitter page</span>
            </a>
            <a href="https://www.instagram.com/podsqueeze/" className="text-[#9685a7] hover:text-gray-900 dark:hover:text-white">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
              </svg>
              <span className="sr-only">Instagram account</span>
            </a>
            <a href="https://www.linkedin.com/company/podsqueeze" className="text-[#9685a7] hover:text-gray-900 dark:hover:text-white">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
              </svg>
              <span className="sr-only">Linkedin account</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
